// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"129":"ff5d06f0","275":"9beae6e5","488":"ff5d06f0","512":"9beae6e5","515":"9beae6e5","813":"9beae6e5","880":"ae3adf68"}[chunkId] + ".chunk.css";
};